import { forwardRef, useContext, useImperativeHandle, useMemo, useRef } from 'react';
import styles from './VerifySupplier.module.scss';
import { DisbursementFormContext } from '../context/DisbursementFormContext';
import { Field, Form, FormSpy } from 'react-final-form';
import arrayMutators from 'final-form-arrays'
import AsyncSelectField from '../AsyncSelectField/AsyncSelectField';
import { useAppSelector } from '../../../redux/reduxHooks';
import { FieldArray } from 'react-final-form-arrays';
import ProductItem from './ProductItem';
import { PiShoppingBagOpenDuotone as ShoppingBagIcon } from "react-icons/pi"
import { DisbursementFormSteps } from '../../../interfaces/interfaces';
import { findFirstErrorField } from '../../../components/functions/utilities';

type Props = {
    ipConfigs: { [x: string]: any }
}

const VerifySupplier = forwardRef(({ ipConfigs }: Props, ref) => {
    const { formData, formStepsValidity, isBtnEnabled, setIsBtnEnabled, formPristine, setFormPristine, setStepValidity } = useContext(DisbursementFormContext);
    const formRef = useRef(null);

    // const { integrationPartners } = useAppSelector((state) => state.config);

    // const { connectionStatus } = useAppSelector((state) => state.connections);

    // const ipConfigs = useMemo(() => {
    //     if (integrationPartners != undefined) {
    //         let configObj = {};
    //         const connectionStatusSet = new Set(connectionStatus);

    //         for (const ip of Object.values(integrationPartners)) {
    //             // console.log('ip', ip)
    //             const logo = ip['logo'];
    //             const ipId = ip["_id"]
    //             // if(connectionStatusSet.has(ip['_id'])) {
    //             configObj[ip['companyName']] = {
    //                 connectionStatus: connectionStatusSet.has(ipId) ? true : false,
    //                 logo
    //             };
    //             // } 
    //         }
    //         return configObj;
    //     } else {
    //         return {};
    //     }
    // }, [integrationPartners, connectionStatus]);

    const manipulateSelectOptions = (onChange, mutators, selectedOption, actionType, allOptions) => {
        // console.log('selectedOption', selectedOption, 'actionType', actionType)
        let existingOptions = allOptions ? [...allOptions] : [];
        if (actionType == 'select-option') {
            // const selectedOptionIndex = existingOptions.findIndex((option) => option.value == selectedOption.value);
            existingOptions = [selectedOption, ...existingOptions];
            onChange('verifiedProducts', existingOptions)
        } else if (actionType == 'deselect-option') {
            // console.log('existing option', existingOptions);
            const selectedOptionIndex = existingOptions.findIndex((option) => option.productId == selectedOption.productId);
            if (selectedOptionIndex != -1) {
                // existingOptions.splice(selectedOptionIndex, 1);
                mutators.remove('verifiedProducts', selectedOptionIndex);
            }
        }
    }

    useImperativeHandle(ref, () => ({
        submitForm: () => {
            return new Promise((resolve) => {
                formRef.current.submit();
                // console.log("pristing", formRef?.current)
                if (!formStepsValidity[DisbursementFormSteps.VERIFY_SUPPLIER]) {
                    scrollToFirstError();
                    resolve({ success: false, values: null, pristine: formRef?.current?.getState().pristine })
                } else {
                    resolve({ success: true, values: formRef?.current?.getState().values, pristine: formRef?.current?.getState().pristine })
                }
            })
        }
    }), [formStepsValidity]);

    const scrollToFirstError = () => {
        try {

            const formState = formRef.current.getState();
            const { errors } = formState;
            console.log('errors', errors);
            // console.log('form state', formState);
            // console.log('formState', formState)
            const firstErrorField = findFirstErrorField(errors);
            // console.log('firstErrorField', firstErrorField);
            const errorField = document.querySelector(`[name="${firstErrorField}"]`);
            // console.log('errorField', errorField);
            if (errorField) {
                errorField.scrollIntoView({ behavior: 'smooth' });
            }
        } catch (error) {
            console.log('error', error)
        }
    };

    return (
        <div className={styles.rootContainer}>
            <div className={styles.innerRootContainer}>
                <div className={styles.supplierDetails}>
                    <div className={styles.label}>
                        SUPPLIER
                    </div>
                    <div className={styles.value}>
                        {formData?.invoiceDetails?.supplierName ?? ''}
                    </div>
                </div>

                <Form
                    initialValues={formData}
                    mutators={{
                        ...arrayMutators
                    }}
                    validate={(values) => {
                        let errors = {};
                        if (!values?.verifiedProducts || !values?.verifiedProducts.length) {
                            errors['verifiedProducts'] = 'Select Products'
                        }
                        return errors;
                    }}
                    onSubmit={(values) => {
                        return {};
                    }}
                    render={({ values: formValues, handleSubmit, form }) => {
                        // console.log('values', values)
                        formRef.current = form;
                        if (formValues?.verifiedProducts?.length) {
                            if (!isBtnEnabled) {
                                setIsBtnEnabled(true);
                            }
                        } else {
                            if (isBtnEnabled) {
                                setIsBtnEnabled(false);
                            }
                        }
                        return (
                            <form className={styles.formWrapper} onSubmit={handleSubmit}>
                                <FormSpy subscription={{ valid: true, pristine: true }} onChange={(state) => {
                                    // console.log('formState', state)
                                    setFormPristine(state.pristine)
                                    // formStepsValidityRef.current[UnderwritingSteps.company] = !state.valid;
                                    setStepValidity(DisbursementFormSteps.VERIFY_SUPPLIER, state.valid)

                                }} />




                                <div className={styles.formRootContainer}>
                                    <div className={styles.selectFieldRootContainer}>
                                        <div className={styles.title}>
                                            Select Previously Purchased Products From the Supplier
                                        </div>
                                        <AsyncSelectField value={formValues?.verifiedProducts} ipConfig={ipConfigs} onChange={(selectedOption, actionType) => {
                                            manipulateSelectOptions(form.change, form.mutators, selectedOption, actionType, formValues.verifiedProducts)
                                        }} />
                                    </div>
                                    <FieldArray name='verifiedProducts'>
                                        {({ fields }) => {
                                            return (
                                                <>
                                                    {fields.length ?
                                                        <div className={styles.productListContainer}>
                                                            <div className={styles.title}>
                                                                Selected Products ({fields.length})
                                                            </div>
                                                            {fields.map((fieldName, fieldIndex) => {
                                                                return (
                                                                    <>
                                                                        <ProductItem key={fieldName} fieldIndex={fieldIndex} fieldName={fieldName} ipConfigs={ipConfigs} />
                                                                        {fields.length - 1 != fieldIndex ? <div className={styles.separator}></div> : null}
                                                                    </>

                                                                )
                                                            })}
                                                        </div>
                                                        :
                                                        <div className={styles.noProductColdState}>
                                                            <div className={styles.iconContainer}>
                                                                <ShoppingBagIcon />
                                                            </div>
                                                            <div className={styles.coldText}>
                                                                No Products Selected!
                                                            </div>
                                                        </div>
                                                    }
                                                </>
                                            )
                                        }}
                                    </FieldArray>
                                </div>
                            </form>
                        )
                    }
                    }
                />

            </div>
        </div>
    );
});

export default VerifySupplier